import { useSelector } from 'react-redux';
import { getInfoStore } from 'domains/Auth/authSlice/authSelectors';

function useGetStoreInfo() {
  return useSelector(getInfoStore);
}

export default useGetStoreInfo;
